var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor create-task" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.title"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("message.title"),
            "show-attributes": true,
            "max-character-count": 500,
          },
          model: {
            value: _vm.clone.title,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "title", $$v)
            },
            expression: "clone.title",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.description"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: _vm.$t("message.description"),
            "show-attributes": true,
            "max-character-count": 2048,
          },
          model: {
            value: _vm.clone.description,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "description", $$v)
            },
            expression: "clone.description",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.priority"))),
        ]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            placeholder: _vm.$t("message.priority"),
            options: _vm.priority,
          },
          model: {
            value: _vm.clone.priority,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "priority", $$v)
            },
            expression: "clone.priority",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.workflow"))),
        ]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            placeholder: _vm.$t("message.workflow"),
            options: _vm.workflows,
          },
          model: {
            value: _vm.clone.workflowId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "workflowId", $$v)
            },
            expression: "clone.workflowId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.pipelineStage"))),
        ]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            disabled: !_vm.clone.workflowId,
            placeholder: _vm.$t("message.pipelineStage"),
            options: _vm.pipelines,
          },
          model: {
            value: _vm.clone.pipelineStageId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "pipelineStageId", $$v)
            },
            expression: "clone.pipelineStageId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.owner"))),
        ]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: { placeholder: _vm.$t("message.owner"), options: _vm.users },
          model: {
            value: _vm.clone.ownerId,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "ownerId", $$v)
            },
            expression: "clone.ownerId",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("message.assignees"))),
        ]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: {
            placeholder: _vm.$t("message.assignees"),
            mode: "multiple",
            options: _vm.users,
          },
          model: {
            value: _vm.clone.assigneeIds,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "assigneeIds", $$v)
            },
            expression: "clone.assigneeIds",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }